/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Task_DecompositionInputs */

const en_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task decomposition`)
};

const ar_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفكيك المهام`)
};

const bn_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টাস্ক ডিকম্পোজিশন`)
};

const de_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgabenzerlegung`)
};

const es_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descomposición de tareas`)
};

const fr_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décomposition des tâches`)
};

const pt_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decomposição de tarefas`)
};

const zh_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任务分解`)
};

const tr_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görev ayrıştırma`)
};

const ru_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Декомпозиция задачи`)
};

const pl_svchip_task_decomposition = /** @type {(inputs: Svchip_Task_DecompositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dekompozycja zadań`)
};

/**
* | output |
* | --- |
* | "Task decomposition" |
*
* @param {Svchip_Task_DecompositionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_task_decomposition = /** @type {((inputs?: Svchip_Task_DecompositionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Task_DecompositionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_task_decomposition(inputs)
	if (locale === "bn") return bn_svchip_task_decomposition(inputs)
	if (locale === "de") return de_svchip_task_decomposition(inputs)
	if (locale === "es") return es_svchip_task_decomposition(inputs)
	if (locale === "fr") return fr_svchip_task_decomposition(inputs)
	if (locale === "pt") return pt_svchip_task_decomposition(inputs)
	if (locale === "zh") return zh_svchip_task_decomposition(inputs)
	if (locale === "tr") return tr_svchip_task_decomposition(inputs)
	if (locale === "ru") return ru_svchip_task_decomposition(inputs)
	if (locale === "pl") return pl_svchip_task_decomposition(inputs)
	return en_svchip_task_decomposition(inputs)
});